import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=6ff80d1c"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=6ff80d1c&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff80d1c')) {
      api.createRecord('6ff80d1c', component.options)
    } else {
      api.reload('6ff80d1c', component.options)
    }
    module.hot.accept("./SvgIcon.vue?vue&type=template&id=6ff80d1c", function () {
      api.rerender('6ff80d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/SvgIcon.vue"
export default component.exports